import magicStyles from './panic-bar.magic.css.js';
import script from './panic-bar.js';
import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panic-bar",attrs:{"part":"panic-bar"}},[(_vm.isSGA)?_c('magic-sga-bar'):_vm._e(),_vm._v(" "),(_vm.isLOTBA && _vm.isLoggedIn)?_c('magic-lotba-bar'):_vm._e(),_vm._v(" "),(_vm.isAGCO && _vm.agcoBarShown)?_c('magic-agco-bar'):_vm._e(),_vm._v(" "),(_vm.isEMTA && _vm.isLoggedIn)?_c('magic-emta-bar'):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-741755e2_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-741755e2";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
